import React from "react";

const Container = ({ children }) => {
  return <div className="w-[90%] mx-auto">{children}</div>;
};

export default Container;
